export default __webpack_public_path__ + "static/media/img9.d5139020.jpg";